// This icon file is generated automatically.
var PScissorOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 12 12", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M6.86 6l4.98-4.99c.08-.08.02-.21-.09-.21h-1.41a.12.12 0 00-.1.03L5.99 5.11 4.57 3.7A2.37 2.37 0 002.5.16 2.38 2.38 0 103.7 4.59L5.09 6 3.7 7.41a2.38 2.38 0 10.88.89l1.4-1.41 4.28 4.28c.02.02.05.03.08.03h1.42c.11 0 .17-.13.09-.21L6.86 6zM2.5 3.78a1.25 1.25 0 110-2.5 1.25 1.25 0 010 2.5zm0 6.94a1.25 1.25 0 110-2.5 1.25 1.25 0 010 2.5z", "fill-rule": "nonzero" } }] }, "name": "p-scissor", "theme": "outlined" };
export default PScissorOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PScissorOutlined.js
// module id = 3621
// module chunks = 0